import { nearestPowerOfTwo } from './IntegerUtilities';
import { assert, release } from './Debug';
var ArrayUtilities = /** @class */ (function () {
    function ArrayUtilities() {
    }
    ArrayUtilities.popManyInto = popManyInto;
    ArrayUtilities.popMany = popMany;
    ArrayUtilities.popManyIntoVoid = popManyIntoVoid;
    ArrayUtilities.pushMany = pushMany;
    ArrayUtilities.top = top;
    ArrayUtilities.last = last;
    ArrayUtilities.peek = peek;
    ArrayUtilities.indexOf = indexOf;
    ArrayUtilities.equals = equals;
    ArrayUtilities.pushUnique = pushUnique;
    ArrayUtilities.unique = unique;
    ArrayUtilities.copyFrom = copyFrom;
    ArrayUtilities.ensureTypedArrayCapacity = ensureTypedArrayCapacity;
    ArrayUtilities.memCopy = memCopy;
    return ArrayUtilities;
}());
export { ArrayUtilities };
/**
 * Pops elements from a source array into a destination array. This avoids
 * allocations and should be faster. The elements in the destination array
 * are pushed in the same order as they appear in the source array:
 *
 * popManyInto([1, 2, 3], 2, dst) => dst = [2, 3]
 */
export function popManyInto(src, count, dst) {
    release || assert(src.length >= count);
    for (var i = count - 1; i >= 0; i--) {
        dst[i] = src.pop();
    }
    dst.length = count;
}
export function popMany(array, count) {
    release || assert(array.length >= count);
    var start = array.length - count;
    var result = array.slice(start, this.length);
    array.length = start;
    return result;
}
/**
 * Just deletes several array elements from the end of the list.
 */
export function popManyIntoVoid(array, count) {
    release || assert(array.length >= count);
    array.length = array.length - count;
}
export function pushMany(dst, src) {
    for (var i = 0; i < src.length; i++) {
        dst.push(src[i]);
    }
}
export function top(array) {
    return array.length && array[array.length - 1];
}
export function last(array) {
    return array.length && array[array.length - 1];
}
export function peek(array) {
    release || assert(array.length > 0);
    return array[array.length - 1];
}
export function indexOf(array, value) {
    for (var i = 0, j = array.length; i < j; i++) {
        if (array[i] === value) {
            return i;
        }
    }
    return -1;
}
export function equals(a, b) {
    if (a.length !== b.length) {
        return false;
    }
    for (var i = 0; i < a.length; i++) {
        if (a[i] !== b[i]) {
            return false;
        }
    }
    return true;
}
export function pushUnique(array, value) {
    for (var i = 0, j = array.length; i < j; i++) {
        if (array[i] === value) {
            return i;
        }
    }
    array.push(value);
    return array.length - 1;
}
export function unique(array) {
    var result = [];
    for (var i = 0; i < array.length; i++) {
        pushUnique(result, array[i]);
    }
    return result;
}
export function copyFrom(dst, src) {
    dst.length = 0;
    pushMany(dst, src);
}
/**
 * Makes sure that a typed array has the requested capacity. If required, it creates a new
 * instance of the array's class with a power-of-two capacity at least as large as required.
 */
export function ensureTypedArrayCapacity(array, capacity) {
    if (array.length < capacity) {
        var oldArray = array;
        array = new array.constructor(nearestPowerOfTwo(capacity));
        array.set(oldArray, 0);
    }
    return array;
}
export function memCopy(destination, source, doffset, soffset, length) {
    if (doffset === void 0) { doffset = 0; }
    if (soffset === void 0) { soffset = 0; }
    if (length === void 0) { length = 0; }
    if (soffset > 0 || (length > 0 && length < source.length)) {
        if (length <= 0) {
            length = source.length - soffset;
        }
        destination.set(source.subarray(soffset, soffset + length), doffset);
    }
    else {
        destination.set(source, doffset);
    }
}
